<div>
    <button mat-raised-button color="accent" (click)="fileUploadInput.click()">
        <mat-icon>cloud_upload</mat-icon>
        {{uploadBtnLabel}}
    </button>
    <input style="display: none;"
           #fileUploadInput
           id="{{elementId}}"
           type="file"
           [multiple]="false"
           [accept]="acceptedFileExtensions"
           (change)="initiateUpload()"
    />
    <div class="padding-top-20">
        <mat-progress-bar mode="indeterminate" *ngIf="uploadInProgress"></mat-progress-bar>
    </div>

</div>